import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, Form } from 'react-bootstrap';
import './style.css';
import { PranchetaMP } from '../../../Icons';
import { useParams } from 'react-router-dom';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoAceite = () => {
  const navigate = useNavigate();
  const { cadastro, handleCadastroChange } = useContext(CadastroContext);
  const { idParam, dbName } = useParams();
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [triedToSubmit, setTriedToSubmit] = useState(false);
  const [tipo, setTipo] = useState('');

  const handleSubmit = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    if (!acceptedTerms) {
      setTriedToSubmit(true);
    } else {
      if (tipo === 'CPF' && cadastro.idConsulta) {
        navigate(`/aso/registro/validar-info/${cadastro.idConsulta}`);
      } else if (tipo === 'CPF' && !cadastro.idConsulta) {
        navigate(`/aso/registro/validar-info/${dbName}`);
      } else {
        cadastro.isEmpresa = true;
        handleCadastroChange(cadastro);
        navigate('/aso/registro/continuar');
      }

    }
  };

  return (
    <Card className="aso-card">
      <Card.Body className='aso-card-body'>
        <div className="icon-text-container d-flex flex-column align-items-center">
          <PranchetaMP className='prancheta-icon' />
          <Card.Title className='cardTitle text-center'>Precisamos validar alguns dados para criar sua conta</Card.Title>
          <Card.Text className='cardSubTitle text-center'>
            Leva só alguns minutos.
          </Card.Text>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formBasicCheckbox" className="mb-1 mb-md-3">
            <Form.Check type="checkbox" className={`aso-termos ${triedToSubmit && !acceptedTerms ? 'bg-invalid' : ''}`}>
              <Form.Check.Input type="checkbox" isInvalid={triedToSubmit && !acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)} />
              <Form.Check.Label>
                Aceito os <a href="/aso/registro/termos" target="_blank" rel="noopener noreferrer">Termos e condições</a> e autorizo o uso de meus dados de acordo com a <a href="/privacidade" target="_blank" rel="noopener noreferrer">Declaração de privacidade</a>.
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
          <Button variant="primary" type="submit" className="btn-aso mb-2 mt-2 w-100" onClick={() => setTipo('CPF')}>
            Criar conta pessoal
          </Button>
          <Button variant="outline-primary" type="submit" className="btn-aso w-100" onClick={() => setTipo('CNPJ')}>
            Criar conta empresa
          </Button>
        </Form>

      </Card.Body>
    </Card>
  );
};

export default AsoAceite;